export type DefaultSenderEmailGroup = {
  accountTypes: string[]
  defaultSenderEmail: string
}

/**
 * Resolve the effective default sender email key for a user.
 * User profile override wins; otherwise account-type admin default; else HOME_EMAIL.
 * Supports group config `[{ accountTypes, defaultSenderEmail }]` and legacy map `{ [accountType]: email }`.
 */
export const resolveDefaultSenderEmail = (
  userDefaultSenderEmail: string | undefined | null,
  accountType: string | undefined | null,
  accountTypeDefaults: Record<string, string> | DefaultSenderEmailGroup[] = {},
): string => {
  if (userDefaultSenderEmail) return userDefaultSenderEmail

  if (Array.isArray(accountTypeDefaults)) {
    if (accountType) {
      const match = accountTypeDefaults.find((group, index) => {
        if (index === 0) return false
        return (group.accountTypes || []).includes(accountType)
      })
      if (match?.defaultSenderEmail) return match.defaultSenderEmail
    }
    return accountTypeDefaults[0]?.defaultSenderEmail || 'HOME_EMAIL'
  }

  if (accountType && accountTypeDefaults[accountType]) return accountTypeDefaults[accountType]
  return 'HOME_EMAIL'
}
